import React, { useState } from 'react';
import { useSession } from '@battleops/client/src/context/SessionContext';
import { resetPassword, noAppMessage, accessEndedMessage } from '@battleops/client/src/session/session';
import Icon from '../components/Icon';
import s from './Login.module.css';

const messageFor = (e) => {
  const code = e?.code || '';
  if (code === 'ops/no-org' || code === 'ops/no-app') return e.message;
  if (/invalid|wrong-password|user-not-found|credential/i.test(code)) return 'That email and password don’t match.';
  if (/too-many/i.test(code)) return 'Too many tries. Wait a minute and try again.';
  if (/network|fetch|timeout|unavailable/i.test(`${code} ${e?.message || ''}`)) return 'No connection. Signing in needs signal once — after that everything works offline.';
  return e?.message || 'Couldn’t sign in.';
};

export default function Login({ expired = false, noAccess = false }) {
  const { signIn, ended } = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [note, setNote] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setBusy(true); setError(null);
    try { await signIn(email, password); } catch (err) { setError(messageFor(err)); setBusy(false); }
  };
  const reset = async () => {
    if (!email) { setError('Type your email first.'); return; }
    try { await resetPassword(email); setNote('Reset link sent. Check your email.'); } catch (err) { setError(messageFor(err)); }
  };

  return (
    <div className={s.wrap}>
      <form className={s.box} onSubmit={submit}>
        <img src="/shield.png" alt="" className={s.shield} />
        <div className={s.word}>BATTLE<span>OPS</span></div>
        <p className={s.sub}>{ended ? accessEndedMessage : noAccess ? noAppMessage : expired ? 'Your session ended. Sign in again — your work is still in this browser.' : 'Sign in with your BattleBooks account.'}</p>
        <label className={s.field}>
          <span className="label">Email</span>
          <input className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.ca" autoFocus />
        </label>
        <label className={s.field}>
          <span className="label">Password</span>
          <div className="row">
            <input className="input" type={show ? 'text' : 'password'} autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
            <button type="button" className="btn icon" onClick={() => setShow(!show)} aria-label={show ? 'Hide password' : 'Show password'}><Icon name={show ? 'eye-off' : 'eye'} /></button>
          </div>
        </label>
        {error ? <div className={s.error}><Icon name="alert-triangle" size={14} />{error}</div> : null}
        {note ? <div className={s.note}>{note}</div> : null}
        <button className="btn primary" style={{ width: '100%', height: 44 }} disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
        <button type="button" className="btn ghost" style={{ width: '100%' }} onClick={reset}>Forgot password</button>
      </form>
    </div>
  );
}
